import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatTabLink, MatTabNav, MatTabNavPanel } from '@angular/material/tabs';
import { RouterLink, RouterLinkActive, RouterOutlet, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-upskilling',
  templateUrl: './upskilling.component.html',
  styleUrl: './upskilling.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatTabNav, MatTabLink, MatTabNavPanel, RouterLink, RouterLinkActive, RouterOutlet],
})
export class UpskillingComponent {
  protected readonly page_title = inject(ActivatedRoute).snapshot.title;

  readonly nav_links = [
    { label: 'Catálogo', link: './catalog' },
    { label: 'Mi historial', link: './history' },
    { label: 'Skills', link: './skills' },
    { label: 'Mis exámenes', link: './exams' },
  ];
}
